'use client';

import { TGenericObject } from '@/ts/types';
import { useCallback, useState } from 'react';

export type SetStateFunction<T extends TGenericObject> = (
  input: ((s: T) => T) | Partial<T>,
) => void;

export type UseSetState<T extends TGenericObject> = [state: T, setState: SetStateFunction<T>];

export const useSetState = <T extends TGenericObject>(value: T): UseSetState<T> => {
  const [state, _setState] = useState<T>(value);

  const setState: SetStateFunction<T> = useCallback((input) => {
    _setState((s) => ({
      ...s,
      ...(typeof input === 'function' ? input(s) : input),
    }));
  }, []);

  return [state, setState];
};
